import script from "./copyAction.vue?vue&type=script&setup=true&lang=js"
export * from "./copyAction.vue?vue&type=script&setup=true&lang=js"

import "./copyAction.vue?vue&type=style&index=0&id=729ec3fe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-729ec3fe"]])

export default __exports__